import { render } from "./tableProfPresenca01.vue?vue&type=template&id=2ea3ac8e&scoped=true"
import script from "./tableProfPresenca01.vue?vue&type=script&lang=js"
export * from "./tableProfPresenca01.vue?vue&type=script&lang=js"

import "./tableProfPresenca01.vue?vue&type=style&index=0&id=2ea3ac8e&lang=scss&scoped=true"
import "./tableProfPresenca01.vue?vue&type=style&index=1&id=2ea3ac8e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea3ac8e"]])

export default __exports__